<template>
  <div class="col">
    <label class="form-label">차량번호</label>
    <div class="p-autocomplete-wrap p-autocomplete-car-num">
      <AutoComplete
          v-model="selectedCarNumIpt"
          :suggestions="filteredCarNumList"
          optionLabel="label"
          @blur="handleCarNumBlur"
          @item-select="handleItemSelect"
          @complete="filterCarNums"
          @show="handleDropdownShow"
          @focus="handleFocus"
          dropdown
          force-selection
          emptySearchMessage="검색 결과가 없습니다."
      />
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, ref, watch} from "vue";
import {useStore} from "vuex";
import {searchBarProps} from "@/store/searchbar";

const emit = defineEmits(['loading']);
const props = defineProps({
})
const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

// 변수
const settings = computed(() => store.state.searchBar.settings);
const carNumMap = computed(() => store.state.searchBar.carNumMap);
const selectedOffice = computed(() => store.state.searchBar.selectedOffice);
const selectedCarNum = computed(() => store.state.searchBar.selectedCarNum);
const carNumList = computed(() => {
  if (!selectedOffice.value) {
    return [];
  }

  if (!carNumMap.value[selectedOffice.value.id]) {
    return [];
  }

  const list = carNumMap.value[selectedOffice.value.id];
  if (settings.value.autoSelectDriver) {
    return list.filter(item => item.id !== null);
  }

  return list;
});
const selectedCarNumIpt = ref(selectedCarNum.value);
const filteredCarNumList = ref([]);


// Methods
function filterCarNums(event) {
  const query = event.query.toLowerCase();
  filteredCarNumList.value = carNumList.value.filter(item =>
      item.label.toLowerCase().includes(query)
  );
}

function handleCarNumBlur() {
  if (selectedCarNumIpt.value === null) {
    if (carNumList.value.length > 0) {
      selectedCarNumIpt.value = carNumList.value[0];
      patchSearchBar({
        prop: searchBarProps.selectedCarNum,
        value: selectedCarNumIpt.value,
      });
    }
  }
}

function handleFocus() {
  if (selectedCarNumIpt.value && selectedCarNumIpt.value.id === null) {
    selectedCarNumIpt.value = null;
  }
}

function handleItemSelect({value}) {
  patchSearchBar({
    prop: searchBarProps.selectedCarNum,
    value,
  });
}

function handleDropdownShow(evt) {
  const targetEl = window.document.querySelector('.p-autocomplete-items .p-highlight')
  if (targetEl) {
    targetEl.scrollIntoView({block: 'center'});
  }
}

watch(
    selectedCarNum,
    (after, _) => {
      if (selectedCarNumIpt.value === after) {
        return;
      }

      selectedCarNumIpt.value = after;
    }
);

</script>

<style>
.p-autocomplete-car-num .p-autocomplete .p-autocomplete-input {
  width: 125px;
}
</style>
